import React, { useState } from 'react'
import DatePicker from "react-datepicker";

const BulkEditPopup = ({ onClose, dropdownOptions, selectedSubscriptions, onSubmit, isLoading }) => {
  const [bulkEditData, setBulkEditData] = useState({
    serviceid: "",
    status: "",
    stype: "",
    servicetype: "",
    order_approval: "",
    amount: "",
    pay_date: "",
    pay_mode: "",
    pay_refno: "",
    sales_manager: "",
    activation_date: "",
    expiry_date: ""
  });

  const handleBulkEditChange = (e) => {
    const { name, value } = e.target;
    setBulkEditData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(bulkEditData)
    onClose()
    setBulkEditData({
      serviceid: "",
      status: "",
      stype: "",
      servicetype: "",
      order_approval: "",
      amount: "",
      pay_date: "",
      pay_mode: "",
      pay_refno: "",
      sales_manager: "",
      activation_date: "",
      expiry_date: ""
    });
  }

  return (
    <div
      className="modal fade show"
      style={{ display: "block" }}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="bulkEditModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <div className="col-md-11">
              <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                Bulk Edit Subscription ({selectedSubscriptions.length}{" "}
                selected)
              </h5>
            </div>
            <button
              type="button"
              className="btn btn-default"
              onClick={onClose}
            >
              &times;
            </button>
            <div className="clearfix"></div>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit} className="form-vertical">
              <div className="panel-body">
                <div className="row">
                  <table class="table table-condensed table-hover bg-white usertable">
                    <tbody>
                      <tr>
                        <td width="140">Service </td>
                        <td>
                          <select
                            name="serviceid"
                            value={bulkEditData.serviceid}
                            onChange={handleBulkEditChange}
                            className="form-control"
                          >
                            <option value="">- select -</option>
                            {dropdownOptions.serviceList &&
                              dropdownOptions.serviceList.map((item, index) => (
                                <option key={index} value={item.id}>
                                  {item.service_name}
                                </option>
                              ))}
                          </select>
                        </td>
                        <td width="140">Status</td>
                        <td>
                          <select
                            name="status"
                            value={bulkEditData.status}
                            onChange={handleBulkEditChange}
                            className="form-control"
                          >
                            <option value="">- select -</option>
                            {dropdownOptions.serviceStatusList &&
                              dropdownOptions.serviceStatusList.map((item, index) => (
                                <option key={index} value={item.pick_name}>
                                  {item.pick_name}
                                </option>
                              ))}
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td>Subscription Type</td>
                        <td>
                          <select
                            name="stype"
                            value={bulkEditData.stype}
                            onChange={handleBulkEditChange}
                            className="form-control"
                          >
                            <option value="">- select -</option>
                            {dropdownOptions.subscriptionTypeList &&
                              dropdownOptions.subscriptionTypeList.map(
                                (item, index) => (
                                  <option key={index} value={item.pick_name}>
                                    {item.pick_name}
                                  </option>
                                )
                              )}
                          </select>
                        </td>
                        <td>Servcie Type</td>
                        <td>
                          <select
                            name="servicetype"
                            value={bulkEditData.servicetype}
                            onChange={handleBulkEditChange}
                            className="form-control"
                          >
                            <option value="">- select -</option>
                            {dropdownOptions.serviceTypeList &&
                              dropdownOptions.serviceTypeList.map((item, index) => (
                                <option key={index} value={item.pick_name}>
                                  {item.pick_name}
                                </option>
                              ))}
                          </select>
                        </td>
                      </tr>

                      <tr>
                        <td>Order Approval</td>
                        <td>
                          <select
                            name="order_approval"
                            value={bulkEditData.order_approval}
                            onChange={handleBulkEditChange}
                            className="form-control"
                          >
                            <option value="">- select -</option>
                            {dropdownOptions.approvalList &&
                              dropdownOptions.approvalList.map((item, index) => (
                                <option key={index} value={item.pick_name}>
                                  {item.pick_name}
                                </option>
                              ))}
                          </select>
                        </td>

                        <td>Amount</td>
                        <td>
                          <input
                            type="text"
                            name="amount"
                            value={bulkEditData.amount}
                            onChange={handleBulkEditChange}
                            className="form-control"
                            placeholder='Amount'
                          />
                        </td>

                      </tr>
                      <tr>
                        <td>Payment Date</td>
                        <td>
                          <DatePicker
                            selected={bulkEditData.pay_date}
                            onChange={(date) =>
                              setBulkEditData((prev) => ({
                                ...prev,
                                pay_date: date,
                              }))
                            }
                            dateFormat="dd-MM-yyyy"
                            className="form-control"
                            placeholderText="Enter Payment Date"
                            wrapperClassName="form-control"
                          />
                        </td>

                        <td>Payment Mode</td>
                        <td>
                          <input
                            type="text"
                            name="pay_mode"
                            value={bulkEditData.pay_mode}
                            onChange={handleBulkEditChange}
                            className="form-control"
                            placeholder="Enter Payment Mode"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Payment Refno.</td>
                        <td>
                          <input
                            type="text"
                            name="pay_refno"
                            value={bulkEditData.pay_refno}
                            onChange={handleBulkEditChange}
                            className="form-control"
                            placeholder="Enter Payment Refno"
                          />
                        </td>
                        <td>Sales Manager</td>
                        <td>
                          <select
                            name="sales_manager"
                            value={bulkEditData.sales_manager}
                            onChange={handleBulkEditChange}
                            className="form-control"
                          >
                            <option value="">- select -</option>
                            {dropdownOptions.salesManagerList &&
                              dropdownOptions.salesManagerList.map((item, index) => (
                                <option key={index} value={item.id}>
                                  {item.user_fullname}
                                </option>
                              ))}
                          </select>
                        </td>
                      </tr>

                      <tr>
                        <td>Activation Date</td>
                        <td>
                          <DatePicker
                            selected={bulkEditData.activation_date}
                            onChange={(date) =>
                              setBulkEditData((prev) => ({
                                ...prev,
                                activation_date: date,
                              }))
                            }
                            dateFormat="dd-MM-yyyy"
                            className="form-control"
                            placeholderText="Enter Activation Date"
                            wrapperClassName="form-control"
                          />
                        </td>

                        <td>Expiry Date</td>
                        <td>
                          <DatePicker
                            selected={bulkEditData.expiry_date}
                            onChange={(date) =>
                              setBulkEditData((prev) => ({
                                ...prev,
                                expiry_date: date,
                              }))
                            }
                            dateFormat="dd-MM-yyyy"
                            className="form-control"
                            placeholderText="Enter Expiry Date"
                            wrapperClassName="form-control"
                          />
                        </td>
                      </tr>

                    </tbody>
                  </table>

                  <div class="col-md-3">
                    <div style={{ float: "left", marginTop: "25px" }}>
                      <button type="submit" class="btn btn-primary" disabled={isLoading}>{isLoading ? "Submitting..." : "Submit"}</button>
                    </div>
                    <div style={{ float: "left", marginTop: "25px", marginLeft: "10px" }}>
                      <button type="button" class="btn btn-default" onClick={onClose}>Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div >
    </div >
  )
}

export default BulkEditPopup
